var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',[_c('TaskHistory',{staticClass:"mt-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }